var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6812 4.86719L31.5146 9.23385C34.3479 10.4839 34.3479 12.5505 31.5146 13.8005L21.6812 18.1672C20.5646 18.6672 18.7312 18.6672 17.6146 18.1672L7.78125 13.8005C4.94792 12.5505 4.94792 10.4839 7.78125 9.23385L17.6146 4.86719C18.7312 4.36719 20.5646 4.36719 21.6812 4.86719Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.332C5 19.732 6.05 21.3487 7.33333 21.9154L18.65 26.9487C19.5167 27.332 20.5 27.332 21.35 26.9487L32.6667 21.9154C33.95 21.3487 35 19.732 35 18.332",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.668C5 28.218 5.91667 29.618 7.33333 30.2513L18.65 35.2846C19.5167 35.668 20.5 35.668 21.35 35.2846L32.6667 30.2513C34.0833 29.618 35 28.218 35 26.668",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.18117dbf7a4c91c87a7dfc9294bc10d1.svg";
export { ForwardRef as ReactComponent };